import api from '../api'

export default {

  brands: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/brands?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  create: async brand => {
    return api.post('api/brands', brand)
  },

  get: async id => {
    return api.get('api/brands/' + id)
  },

  update: async (id,brand) => {
    return api.put('api/brands/' + id, brand)
  },

  delete: async id => {
    return api.delete('api/brands/' + id)
  }
}
